import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { Button } from '@components/main-components/button/Button';
import { Modal } from '@components/main-components/modals/Modal';
import { ModalContext } from '@context/modal';

export function SamTransactionFailedModal({
  transactionType,
}: {
  transactionType: 'Sell' | 'Buy';
}) {
  const { closeCancelModal } = ModalContext.useContainer();

  const modalBody = (
    <Container>
      <Emoji>😑</Emoji>
      <h2>Your transaction failed</h2>
      <p>
        {transactionType === 'Buy'
          ? 'The price has increased because a significant number of editions were collected simultaneously. Please try again.'
          : 'The price has decreased because a significant number of editions were sold simultaneously. Please try again.'}
      </p>
    </Container>
  );

  const Footer = (
    <>
      <Button
        label="Close to Try Again"
        variant="primary"
        size="L"
        onClick={() => {
          closeCancelModal();
        }}
      />
    </>
  );

  return (
    <Modal
      body={modalBody}
      footer={Footer}
      closeModal={closeCancelModal}
      containerStyles={{
        padding: '0 12px 16px',
        '@tablet': {
          padding: '0 16px 20px',
        },
      }}
      headerStyles={{
        paddingTop: 8,

        '@tablet': {
          paddingTop: 12,
        },
      }}
      bodyStyles={{
        marginTop: -4,
      }}
      footerStyles={{
        marginTop: 12,
        justifyContent: 'center',

        '@tablet': {
          marginTop: 16,
        },
      }}
    />
  );
}

const Container = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  height: 'fit-content',
  gap: 12,

  h2: {
    title: 'L',
  },
  p: {
    base: 'M',
  },
});

const Emoji = styled('span', {
  display: 'flex',
  fontSize: 44,
  lineHeight: '46px',

  '@tablet': { fontSize: 54, lineHeight: '56px' },
});
